export { default } from "./MHAFormContainer.gql";
